<template>
    <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" :viewBox="viewBox" role="presentation" style="flex: none;">
        <!-- TODO: Add lang="en" attribute and aria-labelledby="name ? name : null" to the svg-->
        <title v-if="name" :id="name" >{{ name }} icon</title>
        <slot />
    </svg>
</template>

<script>
export default {
    name: 'SvgComponent',
    props: {
        name: {
            type: String,
            default: null,
        },
        width: {
            type: [Number, String],
            default: 18
        },
        height: {
            type: [Number, String],
            default: 18
        },
        viewBox: {
            type: [Number, String],
        }
    }
}
</script>
